import { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import { useDocTypes } from '../../providers/DocTypesContext';
import type { DocumentType } from '@/types/documentTypes';

interface DocumentTypesFieldProps {
  value: DocumentType | null;
  setValue: (value: DocumentType | null) => void;
}

function DocumentTypesField({ value, setValue }: DocumentTypesFieldProps) {
  const options = useDocTypes() || [];

  const [selected, setSelected] = useState<DocumentType | null>(value);

  const handleChange = (_event: unknown, newValue: DocumentType | null) => {
    setSelected(newValue);
    setValue(newValue);
  };

  const hasError = !selected;

  return (
    <Box>
      <Autocomplete
        id='document-types-field'
        options={options}
        value={selected ?? undefined}
        sx={{ width: '100%' }}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        disableClearable={true}
        renderInput={(params) => (
          <TextField
            {...params}
            required
            label='Document Types Filter'
            error={hasError}
            helperText={
              hasError ? 'Please select a document type to continue' : ''
            }
          />
        )}
      />
    </Box>
  );
}

export default DocumentTypesField;

